"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatAppLog = function (_a) {
    var application = _a.application, version = _a.version, runtime = _a.runtime;
    return {
        date: new Date().toISOString(),
        message_type: 'app',
        runtime: runtime,
        application: application,
        version: version,
    };
};
//# sourceMappingURL=formatAppLog.js.map